import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/sections/legal-page'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import LegalPage from '@/components/sections/legal-page'

import { CONTACT } from '@/constants/site'

const SECTIONS: LegalSection[] = [
    {
        heading: "Who we are",
        paragraphs: [
            "This privacy policy explains how BLITZ, a creative marketing agency, collects and uses personal information when you visit this website or contact us through it."
        ]
    },
    {
        heading: "Information we collect",
        paragraphs: [
            "When you send a project inquiry, we collect the details you choose to share: your name, email address, company name, budget range, the services you are interested in and your project description.",
            "We do not ask for sensitive personal information, and we ask that you do not include it in your message."
        ]
    },
    {
        heading: "How we use your information",
        paragraphs: [
            "We use the details from your inquiry only to reply to you, to discuss your project and to prepare a proposal if you ask for one. We do not sell your information or use it for unrelated marketing.",
            "Each inquiry is stored securely in our website database and forwarded to our team by email so we can respond quickly."
        ]
    },
    {
        heading: "Website analytics",
        paragraphs: [
            "We measure visits to this website with privacy-friendly analytics that do not use cookies and do not identify individual visitors. The numbers help us understand which pages are useful and improve the site."
        ]
    },
    {
        heading: "How long we keep information",
        paragraphs: [
            "We keep project inquiries for as long as needed to respond and, if we work together, for the duration of our relationship and any period required by law. You can ask us to delete your inquiry at any time."
        ]
    },
    {
        heading: "Your rights",
        paragraphs: [
            "Depending on where you live, you may have the right to access, correct or delete the personal information we hold about you, or to object to how we use it. To make a request, contact us using the details below and we will respond as soon as we can."
        ]
    },
    {
        heading: "Changes to this policy",
        paragraphs: [
            "We may update this policy from time to time. When we do, we will change the date at the top of this page."
        ]
    },
    {
        heading: "Contact",
        paragraphs: [
            CONTACT.email
                ? `If you have any questions about this policy or your information, email us at ${CONTACT.email} or use the contact form on this website.`
                : "If you have any questions about this policy or your information, please use the contact form on this website."
        ]
    }
]

const PrivacyPage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Privacy policy' description='How BLITZ collects, uses and protects the information you share through this website.' />
            <LegalPage label='Legal' title='Privacy policy' updated='October 16, 2026' sections={SECTIONS} />
        </Layout>
    )
}

export default PrivacyPage
